import * as tslib_1 from "tslib";
import getAllAttachmentIds from './getAllAttachmentIds';
import { getStore as getComposeStore } from '../store/composeStore';
import { assertNever } from 'owa-assert';
import { getStore as getTabStore, TabType } from 'owa-tab-store';
import isTabViewEnabled from 'owa-tab-store/lib/utils/isTabViewEnabled';
export var IdSource;
(function (IdSource) {
    IdSource[IdSource["Compose"] = 0] = "Compose";
    IdSource[IdSource["Attachment"] = 1] = "Attachment";
    IdSource[IdSource["Link"] = 2] = "Link";
    IdSource[IdSource["ComposeItem"] = 3] = "ComposeItem";
})(IdSource || (IdSource = {}));
export default function findComposeViewStateById(id, idSource) {
    var e_1, _a;
    var composeContainsId = getIdChecker(idSource);
    if (isTabViewEnabled()) {
        try {
            for (var _b = tslib_1.__values(getTabStore().tabs), _c = _b.next(); !_c.done; _c = _b.next()) {
                var tab = _c.value;
                if (tab.type === TabType.Compose && composeContainsId(tab.data, id)) {
                    return tab.data;
                }
                else if (tab.type === TabType.Primary) {
                    var composeStore = getComposeStore();
                    if (composeStore.defaultViewState &&
                        composeContainsId(composeStore.defaultViewState, id)) {
                        // TODO: Remove this check once we fully enabled tab view
                        return composeStore.defaultViewState;
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    else {
        var composeStore = getComposeStore();
        // Iterate over all ComposeViewStates.
        var viewStates = [composeStore.defaultViewState, composeStore.pendingViewState];
        // FloatingViewState wraps around ComposeViewState
        var floatingViewStates = composeStore.floatingViewStates &&
            tslib_1.__spread(composeStore.floatingViewStates.values()).map(function (floatingViewState) { return floatingViewState.composeViewState; });
        if (floatingViewStates) {
            viewStates.push.apply(viewStates, tslib_1.__spread(floatingViewStates));
        }
        for (var i = 0; i < viewStates.length; i++) {
            if (viewStates[i] && composeContainsId(viewStates[i], id)) {
                return viewStates[i];
            }
        }
    }
    // We couldn't find composeViewState with a matching ID.
    return null;
}
function getIdChecker(idSource) {
    switch (idSource) {
        case IdSource.Compose:
            return composeIdChecker;
        case IdSource.Attachment:
            return attachmentIdChecker;
        case IdSource.Link:
            return linkIdChecker;
        case IdSource.ComposeItem:
            return composeItemIdChecker;
        default:
            return assertNever(idSource);
    }
}
function linkIdChecker(viewState, linkId) {
    return viewState.attachmentWell.sharingLinkIds.indexOf(linkId) !== -1;
}
function attachmentIdChecker(viewState, attachmentId) {
    return getAllAttachmentIds(viewState).filter(function (x) { return x === attachmentId; }).length !== 0;
}
function composeIdChecker(viewState, composeId) {
    return viewState.composeId === composeId;
}
function composeItemIdChecker(viewState, composeItemId) {
    var bothItemIdsAreNotNull = !!viewState.itemId.Id && !!composeItemId.Id;
    var idsAreEqual = viewState.itemId.Id === composeItemId.Id;
    return bothItemIdsAreNotNull && idsAreEqual;
}
//# sourceMappingURL=findComposeViewStateById.js.map